import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Route, Router, RouterStateSnapshot, UrlSegment, UrlTree } from '@angular/router';

import { Observable } from 'rxjs';
import { map, take, tap } from 'rxjs/operators';

import { BootstrapSandboxService } from '@bootstrap/sandbox/bootstrap.sandbox.service';

@Injectable()
export class AuthGuard {
    private readonly isTokenValid$: Observable<boolean>;
    private readonly isAuthenticated$: Observable<boolean>;

    constructor(
        private readonly sandbox: BootstrapSandboxService,
        private readonly router: Router
    ) {
        this.isAuthenticated$ = this.sandbox.isAuthenticated$;
        this.isTokenValid$ = this.sandbox.isTokenValid$;
    }

    canActivate(_: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
        return this.isTokenValid$.pipe(
            tap(isTokenValid => {
                if (!isTokenValid) {
                    this.sandbox.clearStore();
                }
            }),
            map(result => {
                if (!result) {
                    const loginUrlTree: UrlTree = this.router.parseUrl('/login');
                    loginUrlTree.queryParams = {
                        returnUrl: state.url
                    };

                    return loginUrlTree;
                }

                return result;
            })
        );
    }

    canLoad(_: Route, segments: UrlSegment[]): Observable<boolean> {
        return this.isAuthenticated$.pipe(
            take(1),
            map(isLoggedIn => {
                if (!isLoggedIn) {
                    this.router.navigate(['/login'], {
                        queryParams: {
                            returnUrl: segments.join('/')
                        }
                    });
                }
                return isLoggedIn;
            })
        );
    }
}
